export const CONFIRMED_GET_JOBS = "[Get Action] Confirmed Get jobs";
export const GET_JOBS_FAILED_ACTION = "[Get Action] Get jobs failed";
export const CONFIRMED_GET_ALL_JOBS = "[Get Action] Confirmed Get all jobs";
export const CONFIRMED_GET_SINGLE_JOBS = "[Get Action] Confirmed Get single jobs";
export const ADD_JOB_SUCCESS = "[Post Action] Add Job success";
export const ADD_JOB_FAILED = "[Post Action] Add Job failed";
export const UPDATE_JOB_FAILED = "[Put Action] Update Job failed";
export const UPDATE_JOB_SUCCESS = "[Put Action] Update Job success";
